import { CUSTOM_PARAM_SOURCES } from '../constants/enums';

function unique(arr, same) {
  return arr.reduce((result, item) => {
    if (!result.some(checked => same(checked, item))) {
      result.push(item)
    }
    return result;
  }, [])
}

const isSameCp = (f, s) => {
  return f.sourceName === s.sourceName && f.source === s.source
}

export function isUrlCp({ source = '' } = {}) {
  return source.toLowerCase() === CUSTOM_PARAM_SOURCES.URL;
}

export function convertToValues(customParams) {
  return customParams.map(cp => ({
    sourceName: cp.sourceName,
    source: cp.source,
    value: cp.value
  }))
}

export function findMatchedType(customParams) {
  const uniqueCustomParams = unique(customParams, (f, s) => f.type === s.type);
  return uniqueCustomParams.length === 1 ? uniqueCustomParams[0].type : "Text"
}

export function normalize(customParams) {
  //remove duplicates to adjust for backward compatibility format - saved custom params can contain duplicate values for the same origin (origin name + origin type) 
  return unique(customParams, (f, s) => isSameCp(f, s));
}

export function mergeWithValues(customParams = [], customParamsValues = []) {
  return customParams.map(oCp => {
    const found = customParamsValues.find(cpFromUrl => isSameCp(cpFromUrl, oCp));
    return Object.assign({}, oCp, { value: found != null ? found.value : undefined })
  });
}

export function groupByOrigin(customParams) {
  const result = customParams.reduce((acc, customParam) => {
    //group custom params based on the unique origin name and the type of the origin
    let groupKey = `${customParam.source}_${customParam.sourceName}`
    acc[groupKey] = acc[groupKey] ||
    {
      key: groupKey,// key used as unqiue identifier for state changes (but it is not persisted to url)
      sourceName: customParam.sourceName,
      source: customParam.source,
      cps: []
    }
    acc[groupKey].cps.push(customParam);
    return acc;
  }, {});

  return Object.keys(result).map(key => (result[key]))
}